import { SharableState } from "../../models-v2/SharableState";
import AxiosService from "../../services/axios-service/AxiosService";
import ErrorHandler from "../../utils/ErrorHandler";
import Storage from "../storage/Storage";

const SHARE_API_URL = process.env.REACT_APP_SHARE_API;

export class ShareService {
    static async createSharableState(
        sharableState: SharableState
    ): Promise<String> {
        let token, config;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (error) {
            ErrorHandler.handleError(error);
        }

        config = {
            headers: {
                Authorization: "Bearer " + token
            }
        };

        const url = SHARE_API_URL + "/share";
        const resp = await AxiosService.httpPost(url, sharableState, config);
        return resp.data;
    }
}
